import { IngestResponse } from "@nova/schemas"
import { SocketSlice } from "./types"
import { ingestEventEmitter } from "features/data-management/files/fileManagementApi"

export default {
    events: {
        ingestEvent: () => (payload: string, response: IngestResponse) => {
            ingestEventEmitter.emit(payload, response)
        },
    },
} satisfies SocketSlice
